// `count` always equals `messageIds.length`; an unrecognized `action` fails the
// parse rather than rendering an empty summary.
export type EmailModifyAction =
  | "archive"
  | "unarchive"
  | "mark_read"
  | "mark_unread"
  | "star"
  | "unstar"
  | "mark_important"
  | "mark_not_important"
  | "add_label"
  | "remove_label";

export interface EmailModifyResultPayload {
  type: "email_modify_result";
  action: EmailModifyAction;
  messageIds: string[];
  count: number;
}

const isString = (v: unknown): v is string => typeof v === "string";
const isNumber = (v: unknown): v is number => typeof v === "number" && Number.isFinite(v);

const ACTIONS: ReadonlySet<EmailModifyAction> = new Set([
  "archive",
  "unarchive",
  "mark_read",
  "mark_unread",
  "star",
  "unstar",
  "mark_important",
  "mark_not_important",
  "add_label",
  "remove_label",
]);

const isEmailModifyAction = (v: unknown): v is EmailModifyAction =>
  typeof v === "string" && ACTIONS.has(v as EmailModifyAction);

export const parseEmailModifyResultPayload = (v: unknown): EmailModifyResultPayload | null => {
  if (!v || typeof v !== "object") return null;
  const r = v as Record<string, unknown>;
  if (r.type !== "email_modify_result") return null;
  if (!isEmailModifyAction(r.action)) return null;
  if (!Array.isArray(r.messageIds) || !r.messageIds.every(isString)) return null;
  if (!isNumber(r.count)) return null;
  return {
    type: "email_modify_result",
    action: r.action,
    messageIds: r.messageIds,
    count: r.count,
  };
};
